import { render, staticRenderFns } from "./course-plan-report.vue?vue&type=template&id=2616bed9&scoped=true&"
import script from "./course-plan-report.vue?vue&type=script&lang=js&"
export * from "./course-plan-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2616bed9",
  null
  
)

export default component.exports